module.exports = __webpack_public_path__ + "static/media/notified.b8dc3e91.svg";